export const createModal = (type = '', payload = null) => ({
    type,
    payload
})